var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"visible":_vm.show,"title":"详情","size":"90%"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('div',{staticStyle:{"width":"100%","height":"100%","padding":"20px","box-sizing":"border-box"}},[_c('iframe',{staticStyle:{"width":"100%","height":"99%"},attrs:{"src":_vm.ifarmeUrl,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }